import { render, staticRenderFns } from "./ChooseReward.vue?vue&type=template&id=75567224&"
import script from "./ChooseReward.vue?vue&type=script&lang=js&"
export * from "./ChooseReward.vue?vue&type=script&lang=js&"
import style0 from "./ChooseReward.vue?vue&type=style&index=0&id=75567224&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports